/* eslint-disable */
import { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';
import { useSettingsContext } from 'src/components/settings';
import { useListCorporations } from 'src/api/corporations';
import { useHasFeature } from 'src/api/me';
import { LoadingScreen } from 'src/components/loading-screen';
import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

const BASE_TABS = [
  { value: 'roadmap', label: 'Roadmap', path: paths.dashboard.roadmap.root, icon: 'solar:map-arrow-up-bold-duotone' },
  { value: 'my-suggestions', label: 'Minhas sugestões', path: paths.dashboard.roadmap.mySuggestions, icon: 'solar:lightbulb-bold-duotone' },
];

const TRIAGE_TAB = {
  value: 'triage',
  label: 'Triagem',
  path: paths.dashboard.roadmap.triage,
  icon: 'solar:inbox-line-bold-duotone',
};

function resolveCurrent(pathname) {
  if (pathname.includes('/roadmap/my-suggestions')) return 'my-suggestions';
  if (pathname.includes('/roadmap/triage')) return 'triage';
  return 'roadmap';
}

export default function RoadmapTabsLayout() {
  const settings = useSettingsContext();
  const { pathname } = useLocation();
  const current = resolveCurrent(pathname);

  // Triagem só p/ quem tem a capability roadmap_manager (admin/superuser ou override).
  const { enabled: isManager } = useHasFeature('roadmap_manager');
  // Empresas do usuário: a sugestão deriva a empresa (quando só uma) ou pede escolha.
  const { corporations } = useListCorporations();

  const visibleTabs = isManager ? [...BASE_TABS, TRIAGE_TAB] : BASE_TABS;
  const tabValue = visibleTabs.some((tab) => tab.value === current) ? current : false;

  return (
    <>
      <Container maxWidth={settings.themeStretch ? false : 'xl'}>
        <Stack spacing={2} sx={{ mb: { xs: 2, md: 1 } }}>
          <Tabs value={tabValue}>
            {visibleTabs.map((tab) => (
              <Tab
                key={tab.value}
                value={tab.value}
                label={tab.label}
                component={RouterLink}
                href={tab.path}
                icon={<Iconify icon={tab.icon} width={20} />}
                iconPosition="start"
              />
            ))}
          </Tabs>
        </Stack>
      </Container>

      <Suspense fallback={<LoadingScreen />}>
        <Outlet context={{ corporations: corporations || [], isManager }} />
      </Suspense>
    </>
  );
}
